export default __webpack_public_path__ + "static/media/Icons_Log Out Icon.08508e77.svg";